let $currentElement = null;
const outside = (event) => {
  // Click inside dropdown?
  const isDropdown =
    event.target === $currentElement.target
    || event.target === $currentElement.button
    || $currentElement.target.contains(event.target);

  // Outside?
  if (!isDropdown) {
    event.preventDefault();
    event.stopPropagation();
    $currentElement.button.click();
  }
};

document.addEventListener('click', (event) => {
  if (event.target.matches('.js-dropdown')) {
    const $button = event.target;
    const $target = document.getElementById($button.getAttribute('aria-controls'));

    if ($target) {
      const expanded = $button.getAttribute('aria-expanded') === 'true';

      $button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      $target.setAttribute('aria-hidden', expanded ? 'true' : 'false');
      $target.setAttribute('tabindex', expanded ? '-1' : '0');

      if (!expanded) {
        $target.focus();
        $currentElement = { button: $button, target: $target };
        document.addEventListener('click', outside);
        document.addEventListener('focusin', outside);
      } else {
        $currentElement = null;
        document.removeEventListener('click', outside);
        document.removeEventListener('focusin', outside);
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/javascripts/shared/dropdown.js